:host {
  position: relative;
}
::slotted(*) {
  margin: 0px;
  padding: 0px;
  font-family: var(--primary-font);
  font-weight: var(--font-weight-normal);
  font-style: var(--font-weight-normal);
  color: --var(--color-nero);

  @include supportedTypography();

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul,
  ol,
  img {
    margin-bottom: 20px;
  }

  h1,
  h2 {
    font-weight: var(--font-weight-bold);
  }

  h3,
  h4,
  h5,
  h6 {
    font-weight: var(--font-weight-semibold);
  }

  h1 {
    @include setFontSizeWithDefaultLineHeightRatio(42px);
  }

  h2 {
    @include setFontSizeWithDefaultLineHeightRatio(56px);
  }

  // Common style for mobile / desktop
  h3 {
    @include setFontSizeWithDefaultLineHeightRatio(32px);
  }

  h4 {
    @include setFontSizeWithDefaultLineHeightRatio(24px);
  }

  h5,
  h6 {
    @include setFontSizeWithDefaultLineHeightRatio(20px);
  }

  @include breakpointMin('lg') {
    h1 {
      @include setFontSizeWithDefaultLineHeightRatio(64px);
    }

    h2 {
      @include setFontSizeWithDefaultLineHeightRatio(50px);
    }
  }

  @include supportedColors();

  p {
    font-size: 18px;
    line-height: 1.5;
  }

  a {
    color: var(--color-nero);
  }

  ul {
    // Was commented out before, because the list in the cms 200px indents
    // Was discussed with Beverly and Sven like this
    // padding-left: 200px;

    margin-left: 16px; // Default margin for ul
  }
}

.limited {
  overflow: hidden;
  padding-bottom: 32px;
  line-height: 37px;
  &.closed {
    max-height: 150px;
  }
}

.link {
  position: absolute;
  bottom: -4px;
  width: 100%;
  height: fit-content;
  padding-top: 10px;
  margin-top: 20px;
  background-color: var(--color-white);
  cursor: pointer;
}
